import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';

export const featureFlagsResolver: ResolveFn<boolean> = (): Observable<boolean> => {
  return of(true);
};